import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useHasBUNavIntegration } from 'framework-listing-lib/internal/frameworkAppSettings/hooks/useFrameworkAppSettings';
import BUTooltipHeaderText from './BUTooltipHeaderText';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BUQuickFilterTooltip({
  children
}) {
  const hasBUNavIntegration = useHasBUNavIntegration();
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "bu-nav-tooltip",
    disabled: !hasBUNavIntegration,
    headingText: /*#__PURE__*/_jsx(BUTooltipHeaderText, {}),
    placement: "right",
    padding: "0",
    title: /*#__PURE__*/_jsx(View, {
      as: "div",
      paddingBlockStart: "0",
      paddingInlineEnd: "400",
      paddingBlockEnd: "250",
      paddingInlineStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.buSelect.disabledTooltip_buv2"
      })
    }),
    children: /*#__PURE__*/_jsx("div", {
      children: children
    })
  });
}